// Generated by GitHub Copilot
import { AssetsPage } from '#components/domain/operations/assets/assets-page.tsx'
import { PermissionGuard } from '#components/tools/permission-guard.tsx'
import { PermissionService } from '#core/entities/auth/roles/Permission.ts'
import { readAnyGroups } from '#core/entities/auth/roles/permission-gate-helpers.ts'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/$companyId/assets/')({
  component: RouteComponent,
  staticData: {
    title: 'Assets',
  },
  // Other params (the `slice` an Analysis link adds) pass through untouched; `useListSlice` reads them.
  validateSearch: (search: Record<string, unknown>): Record<string, unknown> => search,
})

function RouteComponent() {
  // Limited readers (any READ_LIMITED slot) may enter; the backend + limited-
  // access whitelists decide which properties they actually see.
  return (
    <PermissionGuard permissions={readAnyGroups(PermissionService.ASSETS)} redirectOnNotAuthorized>
      <AssetsPage />
    </PermissionGuard>
  )
}
